import React from 'react';
import Page from 'components/page/Page';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import { Button, SimpleModal, useBoundForm } from 'common.ui';
import { useUser } from 'contexts/UserContext';
import { useCreateEndUser } from './hooks/useCreateEndUser';
import RoleSection from './components/RoleSection';
import UserInfoSection from './components/UserInfoSection';
import './CreateEndUser.scss';

function CreateEndUser() {
  const { t } = useTranslation('pages');
  const { preferredLangauge } = useUser();

  const {
    values,
    setValues,
    apiErrors,
    applications,
    roles,
    organizationOptions,
    shouldRenderOrganizationDropdown,
    phone,
    isValidPhone,
    setIsValidPhone,
    isValidOrganization,
    setIsValidOrganization,
    email,
    isValidEmail,
    handlePhoneChange,
    handleRoleChange,
    handleApplicationChange,
    validateEmail,
    handleSubmit,
    setSelectedOrganization,
    role,
    selectedOrganization,
    resetKey,
    resultModal,
    closeModal,
    isRolesLoading
  } = useCreateEndUser();

  const { form, FormContainer, isLoading, Input, Dropdown } = useBoundForm({
    onSubmit: async (model) => {
      await handleSubmit(model, () => form.reset());
    },
    errors: apiErrors,
    model: values
  });

  return (
    <Page header={t('createUser.title')} title={t('createUser.title')}>
      <SimpleModal header={resultModal?.title ?? ''} show={!!resultModal} onCancel={closeModal}>
        <p>{resultModal?.message}</p>
        <Button type='button' text={t('createUser.message.closeButton')} onClick={closeModal} />
      </SimpleModal>
      <Container fluid>
        <Row>
          <Col sm={12} lg={12} xl={8}>
            <p>{t('createUser.description')}</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormContainer form={form}>
              <div className='form-section'>
                <RoleSection
                  form={form}
                  BoundDropdown={Dropdown}
                  applications={applications ?? []}
                  roles={roles ?? []}
                  organizationOptions={organizationOptions}
                  shouldRenderOrganizationDropdown={shouldRenderOrganizationDropdown}
                  hasRoleSelected={!!role}
                  isValidOrganization={isValidOrganization}
                  isRolesLoading={isRolesLoading}
                  disabled={isLoading}
                  appValue={values.applicationId}
                  roleValue={role}
                  orgValue={selectedOrganization}
                  resetKey={resetKey}
                  onApplicationChange={handleApplicationChange}
                  onRoleChange={handleRoleChange}
                  onOrganizationChange={setSelectedOrganization}
                />
              </div>
              <div className='form-section'>
                <UserInfoSection
                  form={form}
                  BoundInput={Input}
                  phone={phone}
                  isValidPhone={isValidPhone}
                  email={email}
                  isValidEmail={isValidEmail}
                  preferredLanguage={preferredLangauge}
                  disabled={isLoading}
                  onEmailChange={validateEmail}
                  onPhoneChange={handlePhoneChange}
                  onFirstNameChange={(v) => setValues((prev) => ({ ...prev, firstName: v }))}
                  onLastNameChange={(v) => setValues((prev) => ({ ...prev, lastName: v }))}
                />
              </div>
              <Button
                loading={isLoading}
                text={t('createUser.user.form.buttonLabel')}
                type='submit'
                onClick={() => { setIsValidPhone(true); setIsValidOrganization(true); }}
              />
            </FormContainer>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

export default CreateEndUser;
